'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { RailsRoutes } from '@/helpers/utils';
import { useLocale } from '@/i18n/client';
const linkAnchors = ['#donation-overview', '#donation-receipts', '#donation-recurring'] as const;
export default function useUserLinks(userLoggedIn) {
  const $ = _c(18);
  const t = useTranslations("nextjs");
  const locale = useLocale();
  let t0;
  if ($[0] !== t) {
    t0 = t("footer.donation_overview");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t) {
    t1 = t("footer.donation_receipts");
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("footer.donation_recurring");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t0 || $[7] !== t1 || $[8] !== t2) {
    t3 = [t0, t1, t2];
    $[6] = t0;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const linkLabels = t3 as const;
  if (!userLoggedIn) {
    let t4;
    if ($[10] !== linkLabels || $[11] !== locale) {
      const href = RailsRoutes.askForDonationOverviewToken({
        locale
      });
      t4 = linkLabels.map(label => ({
        href,
        children: label,
        prefetch: false
      }));
      $[10] = linkLabels;
      $[11] = locale;
      $[12] = t4;
    } else {
      t4 = $[12];
    }
    return t4;
  }
  let t4;
  if ($[13] !== locale) {
    t4 = RailsRoutes.userDonationOverview({
      locale
    });
    $[13] = locale;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  const href_0 = t4;
  let t5;
  if ($[15] !== href_0 || $[16] !== linkLabels) {
    t5 = linkLabels.map((label_0, index) => {
      const anchor = linkAnchors[index];
      return {
        href: `${href_0}${anchor}`,
        children: label_0,
        prefetch: false
      };
    });
    $[15] = href_0;
    $[16] = linkLabels;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
}